import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface IReportDialogProps {
	openDialog: boolean
	setOpenDialog: (value: boolean) => void
}

const ReportDialog = ({ openDialog, setOpenDialog }: IReportDialogProps) => {
	const { t } = useTranslation()
	const [loading, setLoading] = useState<boolean>(false)

	useEffect(() => {
		setLoading(true)
	}, [openDialog, loading])

	const handleClose = () => {
		setOpenDialog(false)
	}

	return (
		<Dialog open={openDialog} onClose={handleClose}>
			<DialogTitle>{t("title", { ns: "report" })}</DialogTitle>
			<DialogContent>
				{loading ? (
					<>
						<CircularProgress size={24} />
						<Typography variant="body1" sx={{ mt: 2 }}>
							{t("dialog.loadingDescription", { ns: "report" })}
						</Typography>
					</>
				) : (
					<Typography variant="body1">
						{t("contentDescription", { ns: "report" })}
					</Typography>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="primary">
					{t("close", { ns: "report" })}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ReportDialog
